import React from 'react'
import { Link } from 'react-router-dom';

export const ToolBar = (props) => {
  const {hitos, titulo} = props;

  return (
    <div className="toolbar py-5 py-lg-15" id="kt_toolbar">    
        <div id="kt_toolbar_container" className="container-xxl d-flex flex-stack flex-wrap">        
            <div className="page-title d-flex flex-column me-3">            
                <h1 className="d-flex text-white my-1">{titulo}</h1>
                <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">  
                {hitos.map((hito, i) => (                    
                
                    <li key={i} className="breadcrumb-item pe-0">
                        {
                            hitos.length !== i+1
                            ?
                                <>
                                    <Link to={hito.enlace} className="text-warning text-hover-white">{hito.titulo}</Link> 
                                    <span className="text-white mx-3">/</span>
                                </>
                            :
                                <span className="text-white">{hito.titulo}</span>
                        }
                    </li>

                ))}                                                                             
                </ul>            
            </div>                              
        </div>    
    </div>
  )
}
